import React from 'react';

const EncryptedContentPreview: React.FC = () => {
  return (
    <span className="italic text-gray-400 flex flex-col gap-1 select-none">
      <span className="flex items-center gap-1">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" className="inline-block align-middle">
          <path d="M17 11V7a5 5 0 10-10 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="2"/>
          <circle cx="12" cy="16" r="1" fill="currentColor"/>
        </svg>
        <span className="blur-xs px-2 py-1" style={{display:'inline-block', minWidth: 80}}>
          Lorem ipsum dolor sit amet
        </span>
      </span>
      <span className="blur-xs px-2 py-1" style={{display:'inline-block', minWidth: 120}}>
        Consectetur adipiscing elit
      </span>
      <span className="blur-xs px-2 py-1" style={{display:'inline-block', minWidth: 100}}>
        Sed do eiusmod tempor
      </span>
    </span>
  );
};

export default EncryptedContentPreview;

